<!-- Demo info banner -->
<div class="demo-banner">
  <div class="demo-banner-content">
    <i class="icon-info"></i>
    <span><strong>Demo Chat Interno</strong> — Los mensajes y cambios de etapa llegan automáticamente. El título del navegador muestra los no leídos.</span>
    <div class="demo-stats-inline">
      <span class="stat-pill">{{ chatWindows.length }} conversaciones</span>
      <span class="stat-pill" *ngIf="totalUnread > 0">{{ totalUnread }} sin leer</span>
    </div>
  </div>
</div>

<!-- Chat dock — fixed bottom right -->
<!-- Floating button + contact list -->
<div class="chat-fab" (click)="toggleContactList()">
  <i class="icon-bubble2"></i>
  <span class="fab-badge" *ngIf="totalUnread > 0">{{ totalUnread }}</span>
</div>

<div class="contact-panel" *ngIf="showContactList">
  <div class="contact-panel-header">
    <span><i class="icon-bubble2"></i> Notificaciones</span>
    <i class="icon-cross2" (click)="showContactList = false"></i>
  </div>
  <div class="contact-panel-body">
    <div class="contact-section" *ngIf="chatWindows.length > 0">
      <div class="contact-section-title">Activas</div>
      <div *ngFor="let chat of chatWindows" class="contact-item"
        (click)="toggleChat(chat); showContactList = false">
        <div class="contact-avatar"><i class="icon-user"></i></div>
        <div class="contact-info">
          <span class="contact-name">{{ chat.agentName }}</span>
          <span class="contact-order">{{ chat.orderReference }}</span>
        </div>
        <span class="contact-badge" *ngIf="chat.unreadCount > 0">{{ chat.unreadCount }}</span>
      </div>
    </div>
    <div class="contact-section" *ngIf="inactiveContacts.length > 0">
      <div class="contact-section-title">Iniciar conversación</div>
      <div *ngFor="let contact of inactiveContacts" class="contact-item"
        (click)="startChat(contact)">
        <div class="contact-avatar"><i class="icon-user"></i></div>
        <div class="contact-info">
          <span class="contact-name">{{ contact.name }}</span>
          <span class="contact-order">{{ contact.order }} · {{ contact.role }}</span>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Chat dock — each chat is a column: window on top + tab on bottom -->
<div class="chat-dock">
  <div *ngFor="let chat of openChats; trackBy: trackByChat" class="chat-slot">
    <!-- Window (expands above the tab) -->
    <div class="chat-window" *ngIf="!chat.isMinimized">
      <div class="chat-header" (click)="toggleChat(chat)">
        <div class="chat-header-info">
          <i class="icon-bubble2 chat-header-icon"></i>
          <div class="chat-header-text">
            <span class="chat-agent-name">{{ chat.agentName }}</span>
            <span class="chat-order-ref">{{ chat.orderReference }}</span>
          </div>
        </div>
        <div class="chat-header-actions">
          <i class="icon-minus" (click)="toggleChat(chat); $event.stopPropagation()"></i>
          <i class="icon-cross2" (click)="closeChat(chat, $event)"></i>
        </div>
      </div>
      <div class="chat-body" #chatBody>
        <div *ngFor="let msg of chat.messages; trackBy: trackByMsg"
          class="chat-message" [class.own]="msg.isOwn" [class.system]="msg.isSystem">
          <div class="msg-system" *ngIf="msg.isSystem">
            <i class="icon-sync"></i>
            <span>{{ msg.text }}</span>
            <span class="msg-time">{{ formatTime(msg.time) }}</span>
          </div>
          <div class="msg-bubble" *ngIf="!msg.isSystem">
            <span class="msg-sender" *ngIf="!msg.isOwn">{{ msg.from }}</span>
            <span class="msg-text">{{ msg.text }}</span>
            <span class="msg-time">{{ formatTime(msg.time) }}</span>
          </div>
        </div>
      </div>
      <div class="chat-input">
        <input type="text" [(ngModel)]="chat.newMessage"
          placeholder="Escribe un mensaje..."
          (keyup.enter)="sendMessage(chat)" />
        <button (click)="sendMessage(chat)">
          <i class="icon-paper-plane"></i>
        </button>
      </div>
    </div>
    <!-- Tab (always visible at bottom) -->
    <div class="chat-tab" [class.active]="!chat.isMinimized" [class.has-unread]="chat.unreadCount > 0"
      (click)="toggleChat(chat)">
      <i class="icon-bubble2"></i>
      <span class="tab-name">{{ chat.agentName }}</span>
      <span class="tab-badge" *ngIf="chat.unreadCount > 0">{{ chat.unreadCount }}</span>
      <i class="icon-cross2 tab-close" (click)="closeChat(chat, $event)"></i>
    </div>
  </div>
</div>
